const CONTAINER_ID = 'threeds-container';

export const getContainerElement = () => {
  if (typeof document === 'undefined')
    throw new Error("psd2/getContainerElement can't be used on SSR");

  let element = document.getElementById(CONTAINER_ID);

  if (!element) {
    element = document.createElement('div');
    element.id = CONTAINER_ID;
    document.body.appendChild(element);
  }

  return element;
};
